<template>
  <div :class="{ 'flex items-center': display === 'inline', 'flex flex-wrap': columnWidth }">
    <p
        v-if="label"
        :class="{ 'mr-8': display === 'inline' }"
        class="block font-medium mb-1"
    >
      {{ label }}
    </p>
    <template v-if="options.length">
      <div
          v-for="(option, index) in options"
          :key="index"
          :class="getColumnWidth"
      >
        <div
            :class="getCssClass"
            class="checkbox select-none my-2"
        >
          <input
              v-model="selected"
              :value="option[valueGetter]"
              :name="option[labelGetter]"
              :id="option.id"
              type="checkbox"
              class="checkbox"
          >
          <label class="checkbox-label" :for="option.id">
            <span></span>
            {{ option[labelGetter] }}
          </label>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    columnWidth: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    hasOptionColor: {
      type: Boolean,
      default: false
    },
    labelXs: Boolean,
    color: {
      type: String,
      default: 'border-gray-400 v-input-checkbox-default'
    },
    display: {
      type: String,
      default: ''
    },
    valueGetter: {
      type: String,
      default: 'value'
    },
    labelGetter: {
      type: String,
      default: 'label'
    }
  },
  computed: {
    getId() {
      return this.name ? `${this.name}-${this._uid}` : this._uid;
    },
    getColumnWidth () {
      return this.columnWidth ? `w-full lg:w-${this.columnWidth}` : 'w-full'
    },
    getCssClass () {
      return {
        'opacity-50': !this.required,
        'mr-8': this.display === 'inline' || this.columnWidth
      }
    },
    selected: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
